// Components==============
import AddInput from 'components/UI/AddInput/AddInput';
import Button from 'components/UI/Button/Button';
import Modal from 'components/UI/Modal/Modal';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext } from 'react';
import { MyWorkContext } from '../../MyWork';
import './AddModal.module.scss';
import Row from './Row/Row';
// =========================

export default function AddModal() {
  const translate = useTranslate();

  const {
    portfolios,
    handleAddPortfolio,
    handleAddToPortfolio,
    setAddModalIsOpen,
  } = useContext(MyWorkContext);

  return (
    <Modal size="small" setModalIsOpen={setAddModalIsOpen}>
      <div styleName="modal-content">
        <h1>{translate('work.add-evidence-to-portfolio-popup.title')}</h1>
        <p styleName="description">
          {translate('work.add-evidence-to-portfolio-popup.description')}
        </p>
        {portfolios?.map(
          (p) => !!p && <Row name={p?.name || ''} id={p?.id} key={p?.id} />
        )}

        <p styleName="secondary-title">
          {translate('work.add-evidence-to-portfolio-popup.extra-title')}
        </p>
        <AddInput
          onSubmit={(val) => handleAddPortfolio(val)}
          placeholder={translate(
            'portfolio.manage-portfolios-popup.placeholder'
          )}
        />
        <div styleName="button-wrapper">
          <Button onClick={() => handleAddToPortfolio()}>
            {translate('general.terms.add')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
